<script lang="ts">
	import { ButtonGroup } from "flowbite-svelte-v1";
	import { createEventDispatcher } from "svelte";
	import { twMerge } from "tailwind-merge";
	import Icon from "#lib/components/Icon.svelte";
	import Button from "#lib/ui/Button/index.js";

	interface $$Events {
		toggle: CustomEvent<string>;
	}

	const dispatch = createEventDispatcher();

	export let value = "grid";
</script>

<ButtonGroup size="sm" role="group" aria-label="View mode">
	<Button data-action-name="brand-kit-view-grid" size="sm" color="light" class={twMerge("font-medium", value === "grid" ? "hover:bg-white" : "bg-gray-100 text-gray-600 hover:text-gray-900")} aria-pressed={value === "grid"} onclick={() => dispatch("toggle", "grid")}>
		<span class="sr-only">Grid view</span>
		<Icon name="grid" iconSet="gridicons" />
	</Button>
	<Button data-action-name="brand-kit-view-list" size="sm" color="light" class={twMerge("border-l-0 font-medium", value === "list" ? "hover:bg-white" : "bg-gray-100 text-gray-600 hover:text-gray-900")} aria-pressed={value === "list"} onclick={() => dispatch("toggle", "list")}>
		<span class="sr-only">List view</span>
		<Icon name="list-bullet" />
	</Button>
</ButtonGroup>
